import { atom } from "jotai";
import { DoctorDeclarationSubmittedFragment } from "lib/graphql/megaSchema";

export const patientDeclarationAtom =
  atom<DoctorDeclarationSubmittedFragment | null>(null);
